import React from 'react';
import LinkedAccountsItem from './LinkedAccounts.Item';


const LinkedAccountsTable = ({ linkedAccounts, deleteTabelItem }) => {
  const currentAccount = linkedAccounts.filter(account => account.current)[0];

  return (
    <>
      <div className='linked-accounts__heading'>
        Company
      </div>
      <LinkedAccountsItem
        key={currentAccount.id}
        linkedAccount={currentAccount}
        deleteTabelItem={deleteTabelItem}
      />
      {linkedAccounts
        .filter(account => !account.current)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((linkedAccount) => (
          <LinkedAccountsItem
            key={linkedAccount.id}
            linkedAccount={linkedAccount}
            deleteTabelItem={deleteTabelItem}
          />
      ))}
    </>
  );
};

export default LinkedAccountsTable;
